import React from 'react';
import { T } from '../../../traks';
import { Row,} from 'reactstrap';
import CartItem from './CartItem';
import { CartPackageItem } from './CartPackageItem';
import OrderFooter from '../Globals/OrderFooter';

export const Cart = ({cart, setCart, setView, defaultCurrency, vatRate}) => {
  const handleRemove = () => {
    setCart({});
    setView('order');
  };

  return (
    <div id="cart-inner" className="p-4">
      <div className='cart-order-inner'>
        {cart.lines && cart.lines.length !== 0 ? (
          cart.lines.map((line, idx) => {
            const isPackage = line.addedVia === 'predefined_package';
            const Component = isPackage ? CartPackageItem : CartItem;

            return (
              <Component
                key={line.id || idx}
                line={line}
                lineIndex={idx}
                cart={cart}
                setCart={setCart}
                vatRate={vatRate}
                defaultCurrency={defaultCurrency}
                setView={setView}
                handleRemove={handleRemove}
              />
            );
          })
        ) : (
          <Row className='orderline'>
            <p><T>You have not added any products to the cart yet.</T></p>
          </Row>
        )}
      </div>

      <OrderFooter
            total={cart.lines[0].discountedTotal}
            totalNoVat={cart.lines[0].discountedTotalNoVat}
            onBack={() => setView('order')}
            onNext={() => setView('checkout')}
            nextLabel={<T>Checkout</T>}
        />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/c/PremiumKeys/Cart/Cart.js